// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-buttons-SolidButton-SolidButton-module__button--jUvf0 {
  color: #ffffff;
  background-color: #595959;
  border-color: #595959;
}
.src-components-buttons-SolidButton-SolidButton-module__button--jUvf0:hover:not(:disabled) {
  color: #ffffff !important;
  background-color: #8c8c8c;
  border-color: #8c8c8c !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/buttons/SolidButton/SolidButton.module.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACF;AACE;EACE,yBAAA;EACA,yBAAA;EACA,gCAAA;AACJ","sourcesContent":[".button {\n  color: #ffffff;\n  background-color: #595959;\n  border-color: #595959;\n\n  &:hover:not(:disabled) {\n    color: #ffffff !important;\n    background-color: #8c8c8c;\n    border-color: #8c8c8c !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `src-components-buttons-SolidButton-SolidButton-module__button--jUvf0`
};
export default ___CSS_LOADER_EXPORT___;
